import React from "react";
import { Table } from "semantic-ui-react";

class ItemContacto extends React.Component {
  state = {};

  handleClick = () => {
    const { tipo, email, telefono, descripcion, nombre, id } = this.props;

    const personaFormaContacto =
      tipo === "correo" ? email : tipo === "telefono" ? telefono : tipo;

    this.props.handleClick({
      personaId: id,
      personaNombre: nombre,
      personaFormaContacto,
      descripcion
    });
  };

  render() {
    return (
      <Table.Row
        key={this.props.id}
        style={{ cursor: "pointer" }}
        onClick={this.handleClick}
      >
        <Table.Cell content={this.props.nombre} />
        <Table.Cell content={this.props.email} />
        <Table.Cell content={this.props.telefono} />
        <Table.Cell content={this.props.descripcion} />
      </Table.Row>
    );
  }
}

export default ItemContacto;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/contactos/ItemContacto.jsx